import { SVGProps } from 'react';
const SvgIconTwitterCircle = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 41.201 41.211"
    {...props}
  >
    <g transform="translate(-171.2 -3587.199)">
      <g transform="translate(171.8 3587.8)">
        <path
          d="M-2026.872,281.655a20,20,0,0,1-19.648-20.348,20,20,0,0,1,20.346-19.649,20,20,0,0,1,19.648,20.347,20.01,20.01,0,0,1-14.976,19.017"
          transform="translate(2046.523 -241.655)"
          fill="none"
          stroke="#000"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.2}
        />
        <path
          d="M-2005.286,292.721a14.055,14.055,0,0,0,6.471-11.737q0-.314-.014-.624a9.8,9.8,0,0,0,2.405-2.5,9.622,9.622,0,0,1-2.769.759,4.839,4.839,0,0,0,2.12-2.667,9.665,9.665,0,0,1-3.061,1.17,4.816,4.816,0,0,0-3.52-1.524,4.823,4.823,0,0,0-4.822,4.821,4.826,4.826,0,0,0,.125,1.1,13.687,13.687,0,0,1-9.937-5.038,4.8,4.8,0,0,0-.654,2.423,4.818,4.818,0,0,0,2.146,4.013,4.786,4.786,0,0,1-2.184-.6c0,.02,0,.04,0,.061a4.823,4.823,0,0,0,3.868,4.727,4.832,4.832,0,0,1-1.271.17,4.833,4.833,0,0,1-.906-.087,4.826,4.826,0,0,0,4.5,3.349,9.675,9.675,0,0,1-5.988,2.064,9.8,9.8,0,0,1-1.15-.067"
          transform="translate(2028.889 -264.159)"
          fill="none"
          stroke="#0084f5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.2}
        />
        <path
          d="M-1998,328.371a13.573,13.573,0,0,0,7.247-1.982"
          transform="translate(2014.352 -297.828)"
          fill="none"
          stroke="#0084f5"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth={1.2}
        />
      </g>
    </g>
  </svg>
);
export default SvgIconTwitterCircle;
